import { idOf } from "@/shared/lib/search";

/** The first screen's view, as the address bar holds it: one area, or all of the person's. */
export interface NowSearch {
  /** A service area's id. */
  area?: string;
}

/** Reads the address. Anything it does not know is dropped, never trusted. */
export function parseNowSearch(raw: Readonly<Record<string, unknown>>): NowSearch {
  const area = idOf(raw["area"]);
  return area === undefined ? {} : { area };
}
